import React, { PureComponent, ChangeEvent, Fragment } from 'react'
import classNames from 'classnames'

export interface ICheckboxProps {
  name?: string
  className?: string
  checked?: boolean
  defaultChecked: boolean
  style?: React.CSSProperties
  disabled?: boolean
  onChange?: (e: ChangeEvent<HTMLInputElement>) => void
  value?: any
  children?: React.ReactNode
}

export interface ICheckboxState {
  checked: boolean
}

export default class CheckBox extends PureComponent<
  ICheckboxProps,
  ICheckboxState
> {
  static defaultProps: Partial<ICheckboxProps> = {
    defaultChecked: false,
    className: '',
  }

  static getDerivedStateFromProps(nextProps: ICheckboxProps) {
    if (nextProps.checked !== undefined) {
      return {
        checked: nextProps.checked,
      }
    }
    return null
  }

  constructor(props: ICheckboxProps) {
    super(props)

    const checked =
      props.checked !== undefined ? props.checked : props.defaultChecked
    this.state = {
      checked,
    }
  }

  handleChange = (e: ChangeEvent<HTMLInputElement>) => {
    const { disabled, onChange, checked } = this.props
    if (disabled) {
      return
    }
    if (checked === undefined) {
      this.setState({
        checked: e.target.checked,
      })
    }
    onChange && onChange(e)
  }

  render() {
    const { className, style, name, disabled, value, children } = this.props
    const { checked } = this.state

    const classString = classNames(className, {
      'checkbox-checked': checked,
      'checkbox-disabled': disabled,
    })
    return (
      <Fragment>
        <label className={classString} style={style}>
          <span className="checkbox">
            <input
              className="checkbox-input"
              type="checkbox"
              name={name}
              disabled={disabled}
              value={value}
              checked={checked}
              onChange={this.handleChange}
            />
            <span className="checkbox-inner" />
          </span>
          {children && <span>{children}</span>}
        </label>
        <style jsx>
          {`
            .checkbox {
              color: rgba(0, 0, 0, 0.65);
              font-size: 14px;
              position: relative;
              top: -0.09em;
              display: inline-block;
              line-height: 1;
              white-space: nowrap;
              vertical-align: middle;
              outline: none;
              cursor: pointer;
            }
            .checkbox-input {
              padding: 0;
              position: absolute;
              top: 0;
              right: 0;
              bottom: 0;
              left: 0;
              z-index: 1;
              width: 100%;
              height: 100%;
              cursor: pointer;
              opacity: 0;
            }
            .checkbox-inner {
              position: relative;
              top: 0;
              left: 0;
              display: block;
              width: 18px;
              height: 18px;
              background-color: #fff;
              border: solid 1px #cccccc;
              border-radius: 50%;
              transition: all 0.3s;
            }
            .checkbox-inner::after {
              position: absolute;
              top: 3px;
              left: 5.3px;
              width: 5px;
              height: 8px;
              border: 1px solid #ccc;
              border-top: 0;
              border-left: 0;
              transform: rotate(45deg);
              transition: all 0.2s cubic-bezier(0.12, 0.4, 0.29, 1.46) 0.1s;
              content: ' ';
            }
            .checkbox + span {
              padding-right: 8px;
              padding-left: 8px;
            }
            .checkbox-checked .checkbox-inner {
              background-color: #ffe100;
              border-color: #ffe100;
            }
            .checkbox-checked .checkbox-inner::after {
              border-color: #1a1a1a;
            }
            .checkbox-disabled,
            .checkbox-disabled .checkbox-input {
              cursor: not-allowed;
            }
            .checkbox-disabled .checkbox-inner {
              background-color: #f5f5f5;
            }
            .checkbox-disabled span {
              color: rgba(0, 0, 0, 0.25);
              cursor: not-allowed;
            }
          `}
        </style>
      </Fragment>
    )
  }
}
